
import * as SVGs from './map';
import {TYPES, TYPE_BOOTSTRAP} from './types';
import {computed, defineComponent, h, unref} from 'vue';
// import SVGLoader from '@/components/Icon/SVGLoader.vue';
import SVGLoader from '../Icon/SVGLoader.vue';

export default defineComponent({
  name: 'OxdIcon',

  props: {
    name: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: false,
      default: TYPE_BOOTSTRAP,
      validator: (value: string) => {
        return TYPES.indexOf(value) !== -1;
      },
    },
  },

  setup(props) {
    const classes = computed(() => {
      return {
        'oxd-icon': true,
        [`bi-${props.name}`]: props.type === TYPE_BOOTSTRAP,
      };
    });

    return () =>
      props.type === TYPE_BOOTSTRAP
        ? h('i', {class: unref(classes)})
        : h(
            SVGLoader,
            {class: unref(classes)},
            {default: () => h(SVGs[props.name as never])},
          );
  },
});
